module.exports = __webpack_public_path__ + "img/1-top.74140933.png";